module.exports = __webpack_public_path__ + "static/media/custom-dashboard.79841a42.jpg";